import { Listbox, ListboxButton, ListboxOption, ListboxOptions, Field, Label } from '@headlessui/react'
import React, { Fragment } from 'react'
import { type TCDropdown, type TDefaultOption } from 'core/interface/TCDropdown'
import { _t } from "core/language";
import ArrowDown from 'core/assets/icons/commons/arrow_down.svg';

function CDropdown({
  label,
  options,
  icon,
  value,
  onChange,
  rounded,
  className,
}: TCDropdown) {

  const valueSelected = typeof value !== 'object'
    ? options.find((item: TDefaultOption) => item.id === value)
    : value

  const _onChange = (newValue: TDefaultOption) => {
    return onChange?.(newValue.id, newValue)
  }

  return (
    <Field className={className}>
      {label && <Label className="text-dark text-[13px] mb-[7px]">
        {_t(label)}
      </Label>}
      <Listbox
        name="assignee"
        value={valueSelected}
        onChange={_onChange}
      >
        {({ open }) => (
          <Fragment>
            <ListboxButton
              className={`
                relative w-full block px-[14px] pb-[6px] pt-[6px] leading-none
                focus:outline-none border border-gray-300 hover:border-gray-400
                ${rounded ? 'rounded-full' : 'rounded-lg'}
              `}
            >
              <div className="flex items-center justify-between">
                {icon && <img src={icon} alt="icon" className="w-[15px] h-[15px]" />}
                <span className='px-[10px] font-medium text-[14px] tracking-tighter'>{_t(valueSelected?.name || '')}</span>
                <img src={ArrowDown} alt="icon" className={`${open} w-[18px] h-[18px]`} />
              </div>
            </ListboxButton>
            <ListboxOptions
              anchor="bottom start"
              className={`
                border border-gray-300 bg-white shado
                w-[var(--button-width)] rounded-xl p-1 [--anchor-gap:var(--spacing-1)] focus:outline-none'
                transition duration-100 ease-in data-[leave]:data-[closed]:opacity-0
              `}
            >
              {options.map((item: TDefaultOption) => (
                <ListboxOption
                  key={item.id}
                  value={item}
                  className={`
                    group flex cursor-pointer items-center gap-2 rounded-lg leading-5 text-[13px]
                    py-1.5 px-3 select-none data-[focus]:bg-gray-100
                  `}
                >
                  <div className="text-sm/6 text-dark">{_t(item.name)}</div>
                </ListboxOption>
              ))}
            </ListboxOptions>
          </Fragment>
          )}
      </Listbox>
    </Field>
  )
}

export default CDropdown;
